export interface PrintTextVariables {
  patientName: string;
  patientAddress: string;
  clinicName: string;
  currentDate: string;
  nextScheduleDate: string;
}

export const PLACEHOLDER_EXAMPLES: [string, string][] = [
  ['${patientName}', "the patient's full name"],
  ['${patientAddress}', "the patient's mailing address"],
  ['${clinicName}', "the organization's name"],
  ['${currentDate}', 'the date the letter is printed'],
  ['${nextScheduleDate}', "the patient's upcoming scheduled transmission date(s)"]
];

const replaceAll = (text: string, search: string, replacement: string): string =>
  text.split(search).join(replacement);

export const substitutePrintTextVariables = (text: string, vars: PrintTextVariables): string =>
  [
    ['${patientName}', vars.patientName],
    ['${patientAddress}', vars.patientAddress],
    ['${clinicName}', vars.clinicName],
    ['${currentDate}', vars.currentDate],
    ['${nextScheduleDate}', vars.nextScheduleDate]
  ].reduce((acc, [search, replacement]) => replaceAll(acc, search, replacement), text);

// markdown-to-jsx (and markdown generally) treats a single newline inside a paragraph as a
// soft break — it renders as a space, not a visible line break. Org admins authoring the letter
// press Enter expecting a visible break, so convert single newlines into CommonMark hard breaks
// (two trailing spaces + newline) before handing text to the markdown renderer. Blank-line
// paragraph breaks (2+ newlines) are left alone.
export const preserveLineBreaksForMarkdown = (text: string): string =>
  text
    .split(/\n{2,}/)
    .map((block) => block.split('\n').join('  \n'))
    .join('\n\n');
